export default __webpack_public_path__ + "static/media/mov.f9ec73ce.svg";